import { render } from "./ProgCustomEdit.vue?vue&type=template&id=f363282c"
import script from "./ProgCustomEdit.vue?vue&type=script&lang=js"
export * from "./ProgCustomEdit.vue?vue&type=script&lang=js"

import "./ProgCustomEdit.vue?vue&type=style&index=0&id=f363282c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__